import PropTypes from 'prop-types';
import { head } from 'ramda';
import Presenter from 'utils/PropTypesPresenter';
import { upperFirstLetter } from 'utils/helperMethods';

export default new Presenter(
  {
    id: PropTypes.number,
    friendlyId: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
  },
  {
    fullName(buyer) {
      if (this.firstName(buyer) && this.lastName(buyer)) {
        return `${this.firstName(buyer)} ${this.lastName(buyer)}`;
      }
      const [firstNameText, lastNameText] = this.friendlyId(buyer).split('_');
      return `${upperFirstLetter(firstNameText)} ${upperFirstLetter(lastNameText)}`;
    },
    initials(buyer) {
      if (this.firstName(buyer) && this.lastName(buyer)) {
        return `${head(this.firstName(buyer))}${head(this.lastName(buyer))}`;
      }
      const [firstNameText, lastNameText] = this.friendlyId(buyer).split('_');
      return `${head(firstNameText)}${head(lastNameText)}`.toUpperCase();
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/BuyerPresenter.js